<template>
  <div>
    <router-view v-show="$route.matched.length == 3"></router-view>
    <PageHeaderLayout v-show="$route.matched.length == 2">
      <div class="main-page-content">
        <el-row>
          <el-col :span="6">
            <div class="item-info">
              <img class="item-info-left" :src="leftInfo.img" />
              <div
                class="item-info-right"
                :class="leftInfo.borderRight ? 'border-right' : ''"
              >
                <div class="item-info-title">{{ leftInfo.title }}</div>
                <div class="item-info-price">{{ leftInfo.price }}</div>
                <!-- <el-progress :text-inside="true" :stroke-width="11" :percentage="item.percentage" :status="item.status"></el-progress> -->
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="item-info">
              <img class="item-info-left" :src="centerInfo.img" />
              <div
                class="item-info-right"
                :class="centerInfo.borderRight ? 'border-right' : ''"
              >
                <div class="item-info-title">{{ centerInfo.title }}</div>
                <div class="item-info-price">{{ centerInfo.price }}</div>
                <!-- <el-progress :text-inside="true" :stroke-width="11" :percentage="item.percentage" :status="item.status"></el-progress> -->
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="item-info">
              <img class="item-info-left" :src="rightInfo.img" />
              <div
                class="item-info-right"
                :class="rightInfo.borderRight ? 'border-right' : ''"
              >
                <div class="item-info-title">{{ rightInfo.title }}</div>
                <div class="item-info-price">{{ rightInfo.price }}</div>
                <!-- <el-progress :text-inside="true" :stroke-width="11" :percentage="item.percentage" :status="item.status"></el-progress> -->
              </div>
            </div>
          </el-col>
          <el-col :span="6">
            <div class="item-info">
              <img class="item-info-left" :src="endInfo.img" />
              <div
                class="item-info-right"
                :class="endInfo.borderRight ? 'border-right' : ''"
              >
                <div class="item-info-title">{{ endInfo.title }}</div>
                <div class="item-info-price">{{ endInfo.price }}</div>
                <!-- <el-progress :text-inside="true" :stroke-width="11" :percentage="item.percentage" :status="item.status"></el-progress> -->
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row style="margin-top: 80px; display: flex">
          <el-form size="medium" :inline="true" :model="searchCondition">
            <el-form-item>
              <el-button
                type="primary"
                size="medium"
                icon="el-icon-circle-plus-outline"
                @click="applyInvoice"
                >申请开票
              </el-button>
              <el-button
                v-if="is_batch_open"
                type="primary"
                size="medium"
                icon="el-icon-circle-plus-outline"
                @click="applyBatchInvoice"
                >申请批量开票
              </el-button>
            </el-form-item>
            <el-form-item label="时间">
              <DatePicker @dataSearch="dataSearch" />
            </el-form-item>
            <el-form-item>
              <el-button @click="searchButton" style="color: #1890ff"
                >查询</el-button
              >
            </el-form-item>
            <el-form-item>
              <el-button
              style="margin-left: 60px;"
                v-if="is_batch_open && activeName == 'passThereview'"
                type="primary"
                size="medium"
                @click="batchDownLoad"
                >批量下载发票
              </el-button>
            </el-form-item>
            
          </el-form>
        </el-row>
        <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
          <el-tab-pane
            v-for="(item, index) in this.tabsList"
            :label="item.label"
            :key="index"
            :name="item.name"
            class="tab-item"
          >
          </el-tab-pane>
          <ApeTable
            ref="apeTable"
            :data="dataList"
            :columns="columns"
            :loading="loadingStaus"
            :pagingData="pagingData"
            highlight-current-row
            @switchPaging="switchPaging"
            @selectList="selectList"
          >
            <el-table-column slot="first-column" type="selection"
              v-if="activeName == 'passThereview'"
            ></el-table-column>
            
            <el-table-column align="center" label="开票类目">
              <template slot-scope="scope">
                <div>{{ scope.row.invoice_category_name[0] }}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="开票状态">
              <template slot-scope="scope">
                <div>{{ scope.row.alias_status }}</div>
              </template>
            </el-table-column>
            <el-table-column align="center" label="驳回原因">
              <template slot-scope="scope">
                <div style="color: #f56c6c">{{ scope.row.check_remark }}</div>
              </template>
            </el-table-column>
            <el-table-column
              v-if="activeName == 'billing'"
              align="center"
              label="审核通过时间"
            >
              <template slot-scope="scope">
                <div>{{ scope.row.apply_time }}</div>
              </template>
            </el-table-column>
            <el-table-column width="300" align="left" label="操作">
              <template slot-scope="scope">
                <span
                  class="btn-wrapper"
                  v-if="scope.row.alias_status == '待提交'"
                >
                  <el-button
                    size="mini"
                    type="primary"
                    @click="submitBnt(scope.row.id)"
                    >提交</el-button
                  >
                  <el-popover
                    placement="top"
                    width="160"
                    v-model="scope.row.visible"
                  >
                    <p>确定要删除记录吗</p>
                    <div style="text-align: right; margin: 0">
                      <el-button
                        size="mini"
                        type="text"
                        @click="scope.row.visible = false"
                        >取消</el-button
                      >
                      <el-button
                        type="danger"
                        size="mini"
                        @click="deleteButton(scope.row.id, scope.row.visible)"
                        >确定</el-button
                      >
                    </div>
                    <el-button slot="reference" size="mini" type="danger"
                      >删除</el-button
                    >
                  </el-popover>
                  <el-button
                    v-if="scope.row.recharge_id=='0'"
                    size="mini"
                    type="default"
                    @click="updateBtn(scope.row.id)"
                    >修改</el-button
                  >
                </span>
                <span v-if="scope.row.alias_status != '待提交'">
                  <el-button
                    type="text"
                    @click="viewApplyDetails(scope.row.id)"
                    class="operation-btn"
                    >申请详情</el-button
                  >
                  <el-button
                    type="text"
                    @click="viewBillDetails(scope.row.id)"
                    class="operation-btn"
                    v-if="
                      scope.row.alias_status == '复核中' ||
                      scope.row.alias_status == '复核通过' ||
                      scope.row.alias_status == '复核失败' ||
                      scope.row.alias_status == '发票寄出'
                    "
                    >开票详情</el-button
                  >
                  <el-button
                    size="mini"
                    style="color: #333"
                    @click="toReview(scope.row.id)"
                    class="operation-btn"
                    v-if="scope.row.alias_status == '复核中' && is_can_check_invice"
                    >复核</el-button
                  >
                  <el-button
                    type="text"
                    @click="viewExpressInfo(scope.row.id)"
                    class="operation-btn"
                    v-if="scope.row.alias_status == '发票寄出'"
                    >快递详情</el-button
                  >
                </span>
              </template>
            </el-table-column>
          </ApeTable>
        </el-tabs>
      </div>
      <!-- 查看开票详情 -->
      <ModalDialog
        :dialogData="invoiceDialogData"
        @dialogConfirm="invoiceHandleConfirm"
        @dialogClose="invoiceDialogClose"
        :showButton="showButton"
        :checkTitle="checkTitle"
      >
        <template slot="content">
          <el-form
            :model="invoiceForm"
            ref="invoiceForm"
            class="demo-ruleForm"
            :label-position="'right'"
          >
            <el-form-item prop="invoiceNumber">
              <template slot="label">
                <div class="mail-title">数目：</div>
              </template>
              <span class="mail-content">{{ invoiceForm.invoiceNumber }}</span>
            </el-form-item>
            <el-form-item prop="invoice">
              <template slot="label">
                <div class="mail-title">发票：</div>
              </template>
            </el-form-item>
            <div v-for="(item, index) in invoiceForm.invoice" :key="index">
              <el-tooltip class="box-item" effect="dark" :content="item" placement="top-start"  v-if="item.slice(-4) == '.pdf' || item.slice(-4).toLowerCase() == '.zip' || item.slice(-4).toLowerCase() == '.rar'" > 
                <img
                @click="goPage(item)"
                style="width: 60px; height: auto; cursor: pointer"
                :src="item.slice(-4) == '.pdf' ? 'https://xl-online.oss-cn-hangzhou.aliyuncs.com/xladmin/static/icon_pdf.png' : 'https://img.51xinlong.com/xladmin/static/icon_zip.png'"
              />
              </el-tooltip>
              <img
                :src="item"
                v-else
                :class="index != 0 ? 'new-mail-img' : 'mail-img'"
              />
            </div>
            <div
              v-if="invoiceForm.invoiceNumber > 1"
              @click="expendMore"
              class="expend"
            >
              展开
            </div>
          </el-form>
        </template>
		<template slot='footer'>
			<div style="display: flex;justify-content: flex-end;margin-top: 20px;">
				<el-button size="medium" v-if="!Oneclickdownload"  :loading='sys.loading'   @click="downZIP(invoiceForm.invoice)" >一键下载zip</el-button>
				<el-button size="medium" type="primary" :disabled="invoiceDialogData.loading" v-if="checkTitle=='复核'" @click="invoiceHandleConfirm" >{{checkTitle}}</el-button>
				<el-button size="medium" type="primary"   @click="invoiceDialogClose" >关闭</el-button>
			</div>
		</template>
      </ModalDialog>
      <!-- 查看快递详情 -->
      <ModalDialog
        :dialogData="dialogData"
        @dialogConfirm="handleConfirm"
        @dialogClose="dialogClose"
        :showButton="showButton"
        :checkTitle="checkTitle"
      >
        <template slot="content">
          <el-form
            :model="ruleForm"
            ref="ruleForm"
            class="demo-ruleForm"
            :label-position="'right'"
          >
            <el-form-item prop="expressName">
              <template slot="label">
                <div class="mail-title">快递名称：</div>
              </template>
              <span class="mail-content">{{ ruleForm.expressName }}</span>
            </el-form-item>
            <el-form-item prop="courierNumber">
              <template slot="label">
                <div class="mail-title">快递单号：</div>
              </template>
              <span class="mail-content">{{ ruleForm.courierNumber }}</span>
            </el-form-item>
            <!-- <el-form-item prop="mailImg">
              <template slot="label">
                <div class="mail-title">快递图片：</div>
              </template>
            </el-form-item>
            <div v-for="(item, index) in ruleForm.mailImg" :key="index">
              <img :class="index != 0 ? 'new-mail-img' : 'mail-img'" :src="item" />
            </div>
            <div v-if="ruleForm.mailImg.length > 1" @click="expendMore" class="expend">展开</div> -->
          </el-form>
        </template>
      </ModalDialog>
      <!-- 复核 -->
      <ModalDialog
        :dialogData="toReviewDialogData"
        @dialogConfirm="toReviewHandleConfirm"
        @dialogClose="toReviewDialogClose"
        :showButton="showButton"
      >
        <template slot="content">
          <el-form
            :model="toReviewRuleForm"
            ref="toReviewRuleForm"
            class="demo-ruleForm"
            :label-position="'right'"
          >
            <el-form-item>
              <el-radio-group
                v-model="toReviewRuleForm.invoice_status"
                @change="selectReviewRadio"
              >
                <el-radio label="3">通过</el-radio>
                <el-radio label="5">驳回</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="toReviewRuleForm.invoice_status == 5">
              <el-input
                type="textarea"
                :rows="4"
                v-model="toReviewRuleForm.review_remark"
                placeholder="请输入驳回原因"
              ></el-input>
            </el-form-item>
          </el-form>
        </template>
      </ModalDialog>
      <verification
        @dialogChanged="dialogChanged($event)"
        @onSuccess="handleSuccess($event)"
        :dialogVisible="dialogVisible"
      />
    </PageHeaderLayout>
  </div>
</template>

<script>
import PageHeaderLayout from "@/layouts/PageHeaderLayout";
import ModalDialog from "@/components/ModalDialog";
import Verification from "@/components/Verification";
import ApeTable from "@/components/ApeTable";
import centerImg from "../../../public/img/md-assessment-b.svg";
import leftImg from "../../../public/img/md-assessment-a.svg";
import rightImg from "../../../public/img/md-assessment-c.svg";
import DatePicker from "@/components/DatePicker.vue";
import { mapState } from "vuex";
import {downloadFileUrl} from '@/utils/utils.js'
export default {
  components: {
    PageHeaderLayout,
    Verification,
    ApeTable,
    ModalDialog,
    DatePicker,
  },
  watch: {
    "$route.matched": function (n) {
      if (n.length === 2) {
        this.init();
      }
    },
    "toReviewRuleForm.invoice_status": function (val) {
      if (val) {
        // if(val == 3 && this.toReviewDialogData.visible == false) {
        //   this.searchCondition.status = 2
        //   this.searchCondition.invoice_status = 3
        //   this.init('passThereview')
        //   this.activeName = 'passThereview'
        // }
        // if(val == 5 && this.toReviewDialogData.visible == false) {
        //   this.searchCondition.status = 2
        //   this.searchCondition.invoice_status = 5
        //   this.init('reviewRejected')
        //   this.activeName = 'reviewRejected'
        // }
        this.toReviewDialogData.loading = false;
      } else {
        this.toReviewDialogData.loading = true;
      }
    },
  },
  data() {
    return {
      idList:[],
      isLaowuCompany:false,
      sys:{
        id:'',
        loading:false,
        info:{},
      },
       nowCompany:localStorage.getItem('nowCompany')?JSON.parse(localStorage.getItem('nowCompany')):{},
      toReviewRuleForm: {
        id: "",
        invoice_status: "",
        review_remark: "",
      },
      toReviewDialogData: {
        visible: false,
        title: "",
        width: "40%",
        loading: true,
        modal: false,
      },
      dialogVisible: false,
      searchCondition: {
        status: "",
      },
      invoiceForm: {
        invoiceNumber: "",
        invoice: "",
      },
      Oneclickdownload:false,//一键下载功能显示隐藏
      ruleForm: {
        expressName: "",
        courierNumber: "",
        mailImg: "",
      },
      showButton: ["cancel"],
      checkTitle: "",
      dialogData: {
        visible: false,
        title: "",
        width: "40%",
        loading: false,
        modal: false,
      },
      invoiceDialogData: {
        visible: false,
        title: "",
        width: "40%",
        loading: false,
        modal: false,
      },
      loadingStaus: false,
      // 分页信息
      pagingData: {
        is_show: true,
        layout: "total, sizes, prev, pager, next, jumper",
        total: 0,
      },
      leftInfo: {
        img: leftImg,
        title: "可开票金额",
        price: "",
        borderRight: true,
        percentage: 40,
      },
      centerInfo: {
        img: centerImg,
        title: "开票中金额",
        price: "",
        borderRight: true,
        status: "warning",
        percentage: 70,
      },
      rightInfo: {
        img: rightImg,
        title: "已开票金额",
        price: "",
        borderRight: true,
        status: "success",
        percentage: 90,
      },
      endInfo: {
        img: centerImg,
        title: "退款金额",
        price: "",
        borderRight: false,
        status: "success",
        percentage: 90,
      },
      tabsList: [
        {
          label: "全部",
          name: "all",
        },
        {
          label: "待提交",
          name: "toBeSubmitted",
        },
        {
          label: "审核中",
          name: "toExamine",
        },
        {
          label: "驳回",
          name: "refuse",
        },
        {
          label: "开票中",
          name: "billing",
        },
        {
          label: "复核中",
          name: "underReview",
        },
        {
          label: "复核通过",
          name: "passThereview",
        },
        {
          label: "复核驳回",
          name: "reviewRejected",
        },
        {
          label: "发票寄出",
          name: "invoiceSent",
        },
      ],
      activeName: "all",
      dataList: [],
      columns: [
        {
          title: "编号",
          value: "id",
          header_align: "center",
          align: "center",
        },
        {
          title: "申请开票时间",
          value: "apply_time",
          header_align: "center",
          align: "center",
        },
        {
          title: "申请开票金额",
          value: "invoice_money",
          header_align: "center",
          align: "center",
        }
      ],
      submitId: "",
      module: "",
      mobile: "",
      is_can_check_invice:true,
      is_batch_open:0
    };
  },
  computed: {
    ...mapState({
      user: (state) => state.userInfo,
    }),
  },
  methods: {
    //批量下载发票
    async batchDownLoad() {
      if(!this.idList.length){
        this.$message.warning('请选择一条记录')
        return;
      }
      let result = await this.$api.batchDownLoadInvoice({ids:this.idList});
      if(result){
        downloadFileUrl(result,'发票')
      }
    },
    //选中多选按钮
    async selectList(list) {
      let idList = [];
      list.forEach((item) => {
        idList.push(item.id);
      });
      this.idList = idList
    },
    goPage(e) {
      location.href = e;
    },
    // 处理复核模态框，确定事件
    toReviewHandleConfirm() {
      // 调用组件的数据验证方法
      this.toReviewData();
      this.toReviewRuleForm = {};
      this.toReviewDialogData.visible = false;
    },
    // 处理复核模态框，关闭事件
    toReviewDialogClose() {
      this.toReviewRuleForm = {};
      this.toReviewDialogData.visible = false;
    },
    //选择复核状态
    selectReviewRadio() {
      if (this.toReviewRuleForm.invoice_status == 3) {
        this.toReviewRuleForm.review_remark = "";
      }
    },
    //复核操作
    async toReviewData() {
      let result = await this.$api.toReview(this.toReviewRuleForm);
      if (result) {
        this.$message.success("复核成功");
      } else {
        this.$message.error("复核失败");
      }
      this.init();
    },
    // 搜索
    searchButton() {
      this.init("search");
    },
    //展开更多图片
    expendMore() {
      let node = document.getElementsByClassName("new-mail-img");
      for (let i = 0; i < node.length; i++) {
        node[i].style.display = "block";
      }
      let expend = document.getElementsByClassName("expend")[0];
      expend.style.display = "none";
    },
    //获取数据统计
    async viewDataStatistics() {
      let result = await this.$api.viewDataStatistics();
      if (result) {
        this.leftInfo.price = result.invoice_use_money;
        this.centerInfo.price = result.invoice_process_money;
        this.rightInfo.price = result.invoice_end_money;
        this.endInfo.price = result.refund_money;
      }
    },
    //获取选中日期的值
    dataSearch(value) {
      this.searchCondition.time_value = value;
    },
    //初始化开票列表
    async init(type) {
      if (type) {
        this.mxResetPage();
      }
      this.loadingStaus = true;
      let pagingInfo = this.$refs["apeTable"].getPagingInfo(type);
      if (type == "search") {
        pagingInfo.current_page = 1;
      }
      let searchCondition = this.handleSearchCondition();
      Object.assign(searchCondition, pagingInfo);
      let { list, pages } = await this.$api.getInvoiceListss(searchCondition);
      this.$nextTick(() => {
        this.dataList = list;
      });
      this.pagingData.total = pages.total;
      this.offset = pages.offset;
      this.loadingStaus = false;
    },
    //点击tab切换
    async handleClick(tab) {
      console.log(tab.name, "tab.name");
      if (tab.name == "all") {
        // 全部
        delete this.searchCondition.status;
        delete this.searchCondition.invoice_status;
        this.init("all");
      } else if (tab.name == "toBeSubmitted") {
        // 待提交
        console.log("toBeSubmitted");
        this.searchCondition.status = 0;
        delete this.searchCondition.invoice_status;
        this.init("toBeSubmitted");
      } else if (tab.name == "toExamine") {
        // 审核中
        this.searchCondition.status = 1;
        delete this.searchCondition.invoice_status;
        this.init("toExamine");
      } else if (tab.name == "refuse") {
        // 驳回
        this.searchCondition.status = 3;
        delete this.searchCondition.invoice_status;
        this.init("refuse");
      } else if (tab.name == "billing") {
        // 开票中
        this.searchCondition.status = 2;
        this.searchCondition.invoice_status = 1;
        this.init("billing");
      } else if (tab.name == "underReview") {
        // 复核中
        this.searchCondition.status = 2;
        this.searchCondition.invoice_status = 2;
        this.init("underReview");
      } else if (tab.name == "passThereview") {
        // 复核通过
        this.searchCondition.status = 2;
        this.searchCondition.invoice_status = 3;
        this.init("passThereview");
      } else if (tab.name == "reviewRejected") {
        // 复核驳回
        this.searchCondition.status = 2;
        this.searchCondition.invoice_status = 5;
        this.init("reviewRejected");
      } else if (tab.name == "invoiceSent") {
        // 发票寄出
        this.searchCondition.status = 2;
        this.searchCondition.invoice_status = 4;
        this.init("invoiceSent");
      }
    },
    // 删除表格某条数据
    async deleteButton(id) {
      let args = { id: id };
      let result = await this.$api.invoiceDelete(args);
      if (result) {
        this.$message.success("删除成功");
        this.init();
      } else {
        this.$message.error("删除失败");
      }
    },
    //修改
    updateBtn(id) {
      this.$router.push({
        path: "/invoice/apply",
        query: { id: id, save: "save" },
      });
    },
    //通过
    adopt() {
      this.invoiceDialogData.visible = true;
      this.invoiceDialogData.title = "发票审核";
      this.checkTitle = "通过";
      console.log("通过");
    },
    applyBatchInvoice(){
      this.$router.push({ path: "/invoice/recharge"});
    },
    //申请开票
    applyInvoice() {
      this.$router.push({ path: "/invoice/apply", query: { save: "save",isLaowuCompany:0 } });
    },
    selectRadio() {
      if (this.toReviewRuleForm.invoice_status == 3) {
        this.toReviewRuleForm.review_remark = "";
      }
    },
    //复核
    async toReview(id) {
      this.toReviewRuleForm.id = id;
      this.module = "复核";
      this.invoiceDialogData.title = `复核${id}`;
      this.invoiceDialogData.visible = true;
      this.checkTitle = "复核";
      this.sys.id = id
      let args = {
        id: id,
      };
      let result = await this.$api.invoiceDetail(args);
      if (result) {
        this.invoiceForm = {
          invoiceNumber: result.invoice_img_num,
          invoice: result.invoice_imgs,
        };
      }
    },
    //查看申请详情
    async viewApplyDetails(id) {
      this.$router.push({
        path: "/invoice/detail",
        query: { id: id, title: "在线开票" }
        // query: { id: id, title: "在线开票",isLaowuCompany:JSON.stringify(this.isLaowuCompany) },
      });
    },
    //查看开票详情
    async viewBillDetails(id) {
      this.Oneclickdownload = false
	this.sys.id=id
      this.invoiceDialogData.title = `发票${id}`;
      this.invoiceDialogData.visible = true;
      this.checkTitle = "关闭";
      let args = {
        id: id,
      };
      let result = await this.$api.invoiceDetail(args);
      console.log(result);
      if (result) {
		this.sys.info=result
        this.invoiceForm = {
          invoiceNumber: result.invoice_img_num,
          invoice: result.invoice_imgs,
        };
        if(result.invoice_imgs.length !== 0) {
          result.invoice_imgs.forEach(ele => {
            if(ele.slice(-4).toLowerCase() == '.zip' || ele.slice(-4).toLowerCase() == '.rar') {
              this.Oneclickdownload = true
            }
          })    
        }
      }
    },
	async downZIP(arr){
		if(!arr?.length){
			return   this.$message.warning("暂无发票");
		}
		if(this.sys.info.zip_url){
		return	downloadFileUrl(this.sys.info.zip_url,'发票')
		}
		console.log(this.sys,'返回结果')
		this.sys.loading=true
		let result = await this.$api.downZIP({id:this.sys.id});
		this.sys.loading=false
		if(!result){
			return   this.$message.warning("正在生成中 ,稍后再试");
		}
		downloadFileUrl(result,'发票')
		console.log(result)
	},
    //查看快递信息
    async viewExpressInfo(id) {
      this.checkTitle = "关闭";
      this.dialogData.title = `快递信息查看${id}`;
      this.dialogData.visible = true;
      let args = { id: id };
      let result = await this.$api.expressDetails(args);
      if (result) {
        this.ruleForm = {
          expressName: "顺丰",
          courierNumber: result.express_no,
          mailImg: result.express_img.split(","),
        };
      }
    },
    // 处理模态框，确定事件
    handleConfirm() {
      // 调用组件的数据验证方法
      this.dialogData.visible = false;
    },
    // 处理模态框，关闭事件
    dialogClose() {
      this.dialogData.visible = false;
    },

    //保存复核数据
    async saveReview() {
      this.$message.success("复核成功");
    },

    //处理发票模态框，确定事件
    invoiceHandleConfirm() {
      if (this.module == "复核") {
		this.sys.id = this.toReviewRuleForm.id;
        this.toReviewDialogData.visible = true;
        this.toReviewDialogData.title = `复核${this.toReviewRuleForm.id}`;
        this.toReviewDialogData.visible = true;
      }
      this.invoiceForm = {};
      this.invoiceDialogData.visible = false;
    },
    //处理发票模态框，关闭事件
    invoiceDialogClose() {
      this.invoiceForm = {};
      this.invoiceDialogData.visible = false;
    },
    // 处理搜索条件
    handleSearchCondition() {
      let condition = {};
      if (this.searchCondition.status === 0 || this.searchCondition.status) {
        condition.status = this.searchCondition.status;
      }
      if (
        this.searchCondition.invoice_status === 0 ||
        this.searchCondition.invoice_status
      ) {
        condition.invoice_status = this.searchCondition.invoice_status;
      }
      if (this.searchCondition.time_value) {
        condition.time = {
          start_time: this.searchCondition.time_value[0],
          end_time: this.searchCondition.time_value[1],
        };
      }
      return condition;
    },
    // 提交
    submitBnt(id) {
      this.submitId = id;
      this.dialogVisible = true;
      this.isTel = 0;
    },
    // 确定验证手机号弹框
    handleSuccess() {
      this.submitInvoice();
      this.dialogVisible = false;
    },
    //提交在线开票
    async submitInvoice() {
      let args = { id: this.submitId };
      let result = await this.$api.invoiceSubmit(args);
      if (result) {
        this.$message.success("提交成功");
        if (this.activeName == "all") {
          this.init();
        } else {
          this.searchCondition.status = 1;
          delete this.searchCondition.invoice_status;
          this.init("toExamine");
          this.activeName = "toExamine";
        }
      } else {
        this.$message.error("提交失败");
      }
    },
    // 关闭验证手机号弹框
    dialogChanged(state) {
      this.formData = {};
      this.dialogVisible = state;
    },
    //分页
    switchPaging() {
      this.init();
    },
	// 是否是劳务公司
	async getIsLaoWu(){
		let settlementList = await this.$api.getUserSettlement({
			company_id:JSON.parse(localStorage.getItem('nowCompany')).id
		})
		console.log(settlementList)
		let companyIds = JSON.parse(localStorage.getItem('user_info')).settlement_id.replaceAll(/"/g,'')
		let newSettlementList = Object.assign(settlementList, [])
		
		newSettlementList.map(item=>{
			if(item.id == companyIds){
				if(item.is_labor_dispatch != 0){
					this.isLaowuCompany = true
				}
			}
		})
		
		console.log(this.isLaowuCompany,'返回标识')
	},
  // 是否支持批量开票
	async getIsBatch(){
		let {is_batch} = await this.$api.isInvoiceBatch()
		this.is_batch_open = is_batch
	},
  },
  mounted() {
    this.getIsBatch();
    this.getIsLaoWu();
    this.init();
    this.viewDataStatistics();
    let shuiyoudiList = ['sycard', 'syalipay', 'sywechat']
    let lignxinList = ['lingxin','lingxincard','lingxinalipay','lingxinwechat']
    if(lignxinList.includes(this.nowCompany.trade_bank_type) || shuiyoudiList.includes(this.nowCompany.trade_bank_type)){
        this.is_can_check_invice = false
    }
  },
};
</script>

<style lang="stylus" scoped>
.el-button {
  margin-right: 4px;
  margin-bottom: 4px;
}

.operation-btn {
  margin: 0 20px;
}

.el-button + .el-button {
  margin-left: 0;
}

.item-info {
  display: flex;
  flex-direction: row;
}

.item-info-left {
  width: 130px;
  height: 100px;
}

.item-info-right {
  width: 50%;
  // padding: 15px;
  line-height: 50px;
}

.item-info-title {
  color: #aeaeb2;
  font-size: 18px;
}

.item-info-price {
  color: #101010;
  font-size: 28px;
}

.item-info-progress {
  width: 76px;
  height: 11px;
  border: 1px solid black;
}

.border-right {
  border-right: 2px solid #BBBBBB;
}

.application-wrapper {
  width: 116px;
  margin-left: 30px;
}

.new-mail-img {
  display: none;
  width: 100%;
}

.mail-img {
  width: 100%;
}

.btn-wrapper {
  margin-left: 16px;
}

/deep/ .btn-wrapper .el-button--mini {
  margin: 0 4px;
}

/deep/ .btn-wrapper .el-button--text {
  margin: 0 4px;
}

.mail-title {
  color: rgba(16, 16, 16, 100);
  font-size: 16px;
}

.mail-content {
  color: rgba(16, 16, 16, 100);
  font-size: 16px;
}

.expend {
  text-align: center;
  margin-top: 20px;
  color: #333;
}

.invoicePDF {
  text-decoration: none;
  text-align: center;
  display: block;
}
</style>






